import React from 'react';
import * as yup from 'yup';
import CrudPage from '@modules/cruds/CrudPage';
import { defaultConfigComponent } from './KpiOperations';
import KpiOperationsForm from './KpiOperationForm';

const kpiOperationsSchema = yup.object().shape({
  name: yup.string().nullable().required().label('Name'),
  kpiOperationType: yup
    .mixed()
    .test('is-string-or-object', 'KpiOperation', value => {
      return typeof value === 'string' || typeof value === 'object';
    })
    .required()
    .label('KPI Operation'),
  data: yup.object().test('data-validation', async function (value) {
    const { kpiOperationTypeId } = this.parent; // Accede a otros campos del objeto

    switch (kpiOperationTypeId) {
      case 'value_between_readings':
        try {
          await yup
            .object()
            .shape({
              readingTypeId: yup.string().required().label('Reading Type'),
            })
            .validate(value);
          return true; // Validación exitosa
        } catch (error: any) {
          return this.createError({ message: error.message });
        }
      case 'inter_event_item_usage':
      case 'time_between_events':
      case 'interval_summation':
        try {
          await yup
            .object()
            .shape({
              startEventType: yup
                .object()
                .shape({
                  eventTypeId: yup.string().nullable().required('Start Event Type ID is required'), // Mensaje personalizado
                })
                .required('Start Event Type is required'), // Mensaje personalizado
              endEventType: yup
                .object()
                .shape({
                  eventTypeId: yup.string().nullable().required('End Event Type ID is required'), // Permitir null
                })
                .required('End Event Type is required'), // Mensaje personalizado
            })
            .validate(value);
          return true; // Validación exitosa
        } catch (error: any) {
          return this.createError({ message: error.message });
        }
      default:
        return true; // O cualquier otra lógica por defecto
    }
  }),
});

const KPIOperationPage = props => {
  return (
    <CrudPage
      key={'kpiOperationPage'}
      configComponent={defaultConfigComponent}
      form={KpiOperationsForm}
      defaultValues={{
        data: {},
      }}
      essentialValues={new Set(['name', 'logicalId', 'data'])}
      validationSchema={kpiOperationsSchema}
    />
  );
};

export default KPIOperationPage;
